module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold.3dce58bf.woff2";